import { useMemo } from "react";

import { PRODUCT_SALE_PARAMETER } from "@/configs/system";
import { CartModel } from "@/models/cart/type";
import { ProductModel } from "@/models/product/type";

type UsePricesProps = {
  product: ProductModel;
  quantity: number;
  cartTotalPrice: number;
  subscriptionEnabled: boolean;
  cart?: CartModel;
};

export function usePrices({
  product,
  quantity,
  cartTotalPrice,
  subscriptionEnabled,
  cart,
}: UsePricesProps) {
  return useMemo(() => {
    const firstSubscriptionSubtotal = product.firstSubscriptionPrice * quantity;
    const afterSecondSubscriptionSubtotal = product.afterSecondSubscriptionPrice * quantity;
    const normalSubtotal = product.normalPrice * quantity;

    const productAndCartTotal =
      (subscriptionEnabled ? firstSubscriptionSubtotal : normalSubtotal) + cartTotalPrice;
    const freeShippingPrice =
      cart &&
      cart.isSubscription &&
      cart.amountUpToFreeShipping &&
      cart.amountUpToFreeShipping > 0 &&
      !product.isFreeze
        ? cart.amountUpToFreeShipping
        : 0;

    return {
      firstSubscriptionSubtotal,
      afterSecondSubscriptionSubtotal,
      normalSubtotal,
      firstSubscriptionGapPrice:
        (product.normalTotalPrice - product.firstSubscriptionPrice) * quantity,
      afterSecondSubscriptionGapPrice:
        (product.normalTotalPrice - product.afterSecondSubscriptionPrice) * quantity,
      minimumPurchasePrice: product.isFreeze
        ? PRODUCT_SALE_PARAMETER.minDeliveryAmountFrozen
        : PRODUCT_SALE_PARAMETER.minDeliveryAmountNormal,
      productAndCartTotal,
      freeShippingPrice,
    };
  }, [
    cart,
    cartTotalPrice,
    product.afterSecondSubscriptionPrice,
    product.firstSubscriptionPrice,
    product.isFreeze,
    product.normalPrice,
    product.normalTotalPrice,
    quantity,
    subscriptionEnabled,
  ]);
}
